import classNames from '../../utils/classNames'

// 'YYYY-MM-DD HH:mm:ss' (what the backend sends) is wide enough to squeeze the
// subject into a wrapped column, and the seconds carry no meaning here — so the
// stamp is split over two lines and the seconds dropped. Anything that doesn't
// match the expected shape is rendered as-is rather than mangled.
const SEND_TIME = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/

const SendTime = ({
  value,
  className,
}: {
  value: string
  className?: string
}) => {
  const parts = SEND_TIME.exec(value ?? '')

  return (
    <span
      className={classNames(
        'shrink-0 text-right whitespace-nowrap text-[10px] leading-[14px] text-secondary-txt font-normal font-[Poppins]',
        className,
      )}>
      {parts ? (
        <>
          <span className="block">{parts[1]}</span>
          <span className="block">{parts[2]}</span>
        </>
      ) : (
        value
      )}
    </span>
  )
}

export default SendTime
